import axios from 'axios';
import authService from '@/services/authService';

const api = axios.create({
    baseURL: 'https://rverdeadmin.klatus.systems/api/v2/',    
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 3000,
});

// Interceptor para agregar el token de autenticación a cada petición
api.interceptors.request.use(
    (config) => {
        const token = authService.getAccessToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Interceptor para manejar errores de autenticación
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            // Token expirado o inválido - cerrar sesión
            authService.logout();
            window.location.href = '/auth/login';
        }
        return Promise.reject(error);
    }
);

export default api;